import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('intercom', ['isIntercomReady']),
    isIntercomEnabled() {
      return this.$statsig.ready && this.$statsig.checkGate('chat_provider_intercom');
    },
  },
  methods: {
    ...mapActions('hubspot', [
      'hideHubSpotIcon',
      'showHubSpotIcon',
    ]),
    ...mapActions('intercom', [
      'hideIntercomIcon',
      'showIntercomIcon',
    ]),
    hideSupportChatIcon() {
      if (this.isIntercomEnabled && this.isIntercomReady) {
        return this.hideIntercomIcon();
      }

      return this.hideHubSpotIcon();
    },
    showSupportChatIcon() {
      if (this.isIntercomEnabled && this.isIntercomReady) {
        return this.showIntercomIcon();
      }

      return this.showHubSpotIcon();
    },
  },
};
